export var TargetAudience = /*#__PURE__*/function (TargetAudience) {
  TargetAudience["activeOrChurned"] = "activeOrChurned";
  TargetAudience["npu"] = "npu";
  return TargetAudience;
}(TargetAudience || {});
/**
 * @description
 * Enum of the tags that a discount code can have.
 * Tags that are a part of `discountCodeTagToHardwareId` in `product.util.ts` will trigger setHwId when placing an order.
 */
export var DiscountCodeTag = /*#__PURE__*/function (DiscountCodeTag) {
  DiscountCodeTag["t1HwId"] = "t1HwId";
  DiscountCodeTag["t2HwId"] = "t2HwId";
  DiscountCodeTag["t3HwId"] = "t3HwId";
  DiscountCodeTag["ouraHwId"] = "ouraHwId";
  DiscountCodeTag["awHwId"] = "awHwId";
  /**
   * @deprecated
   * Previously used to identify a discount code as a clearblue discount code.
   * Now replaced with the `activationChannel` field in the discount code model.
   */
  DiscountCodeTag["clearblue"] = "clearblue";
  /**
   * Specifies that the discount code should only be applied if there is a yearly subscription in the cart.
   * Otherwise, the code will silently not be applied.
   */
  DiscountCodeTag["applyIfHasYearly"] = "applyIfHasYearly";
  return DiscountCodeTag;
}(DiscountCodeTag || {});